const CampaignEdit = () => import('@/modules/campaigns/views/CampaignEdit.vue')
const CampaignIndex = () => import('@/modules/campaigns/views/CampaignIndex.vue')
const CampaignShow = () => import('@/modules/campaigns/views/CampaignShow.vue')
const ImportDv360Show = () => import('@/modules/campaigns/views/import/ImportDv360Show.vue')
const ImportMgidShow = () => import('@/modules/campaigns/views/import/ImportMgidShow.vue')

export default [
  {
    path: '/campaigns/create',
    name: 'campaigns.create',
    component: CampaignEdit,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns',
    name: 'campaigns.index',
    component: CampaignIndex,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns/import/dv360',
    name: 'campaigns.import.dv360',
    component: ImportDv360Show,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns/import/mgid',
    name: 'campaigns.import.mgid',
    component: ImportMgidShow,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns/:id/edit',
    name: 'campaigns.edit',
    component: CampaignEdit,
    props: true,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/campaigns/:id',
    name: 'campaigns.show',
    component: CampaignShow,
    props: true,
    meta: { requiresAuthentication: true }
  }
]
